import React from 'react';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import Dialog from 'material-ui/Dialog';

import { saveAs } from 'file-saver';

import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';
import  GetInvoice from  '../../components/GetInvoice'
import $ from "jquery";
import * as Cookies from "../../utils/Cookies";

const modalStyle = {
    width: '80%',
    height: '90%;',
    maxWidth: 'none',
    maxHeight: 'none',
};
const styles = {
    marginSide:{
        marginLeft: '1em'
    }
};

class Bills extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            allOrders: [],
            filteredOrders: [],
            allFarmers: [],
            allVouchers: [],
            allExpenses: [],
            farmerId: null,
            allFarmerVouchers: false,
            farmerProfile: [],
            active: "",
            filteredVouchers: [],
            filteredUnpaidVouchers:[],
            paidVouchers: [],
            unpaidVouchers: [],
            open:false,
            invoice:null,
            profile:null,
            searchName:"",
            searchNameUnpaid:""
        };

        this.handleError = this.handleError.bind(this)
        this.successGetVouchers = this.successGetVouchers.bind(this)
        this.handleViewInvoice = this.handleViewInvoice.bind(this)
        this.handleReceivedProfile = this.handleReceivedProfile.bind(this)
        this.handleSendToEmail = this.handleSendToEmail.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleunpaidFilterChange=this.handleunpaidFilterChange.bind(this)
        this.filterUnpaidFarmers=this.filterUnpaidFarmers.bind(this)
    }
    handleViewInvoice(invoice){
        this.setState({
            open:true,
            invoice:invoice
        })
    }
    handleClose(){
        this.setState({
            open:false,
        })
    }
    handleReceivedProfile(data){
        let self=this
        this.setState({
            profile:data
        },function () {
            let body = {
                "type": "getAllVouchersExpenditure"
            }
            Connections.performSecureRequest(body, self.successGetVouchers, self.handleError)
        })
    }
    componentDidMount() {
        let body = {
            "type": "getMyProfile"
        }
        Connections.performSecureRequest(body, this.handleReceivedProfile, this.handleError)

    }
    handleSendToEmail() {
        var sendData = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            body: $.param({
                type: "getFundingInvoice",
                token: Cookies.checkCookie("accessToken"),
                invoiceId:this.state.invoice.voucher.id

            })
        };
        let self = this;
        fetch(Connections.getLinkLocation(), sendData)
            .then(response => response.blob())
            .then(blob => saveAs(blob, "DASH" + self.state.mainKey + ".pdf"));
    }

    handleError(data) {
        alert(data)
    }

    successGetVouchers(data1) {
        console.log(data1)
        let self = this
        this.setState({
            allVouchers: data1,
            paidVouchers: data1.filter(function (voucher) {
                return voucher.voucher.state === 1
            }),
            filteredVouchers: data1.filter(function (voucher) {
                return voucher.voucher.state === 1
            }),
            filteredUnpaidVouchers: data1.filter(function (voucher) {
                return voucher.voucher.state === 0
            }),
            unpaidVouchers: data1.filter(function (voucher) {
                return voucher.voucher.state === 0
            }),
        }, function () {
            console.log(self.state)
        })
    }

    handleDateChange = date => {
        this.setState({selectedDate: date});
    };

    filterFarmers() {
        let toUse = this.state.paidVouchers
        let self = this
        if (this.state.searchName !== "") {
            toUse = toUse.filter(function (farmer) {
                return (
                    farmer.voucher.farmerDetails.name.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.voucher.farmerDetails.surname.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.voucher.farmerDetails.phone.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.voucher.farmerDetails.email.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.voucher.farmerDetails.username.toLowerCase().includes(self.state.searchName.toLowerCase()) ||
                    farmer.voucher.farmerDetails.farmName.toLowerCase().includes(self.state.searchName.toLowerCase())
                )
            })
        }
        console.log(this.state.searchName)
        this.setState({
            filteredVouchers: toUse,
        })
    }

    filterUnpaidFarmers() {
        let toUse = this.state.unpaidVouchers
        let self = this
        if (this.state.searchNameUnpaid !== "") {
            toUse = toUse.filter(function (farmer) {
                return (
                    farmer.voucher.farmerDetails.name.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase()) ||
                    farmer.voucher.farmerDetails.surname.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase()) ||
                    farmer.voucher.farmerDetails.phone.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase()) ||
                    farmer.voucher.farmerDetails.email.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase()) ||
                    farmer.voucher.farmerDetails.username.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase()) ||
                    farmer.voucher.farmerDetails.farmName.toLowerCase().includes(self.state.searchNameUnpaid.toLowerCase())
                )
            })
        }
        console.log(this.state.searchNameUnpaid)
        this.setState({
            filteredUnpaidVouchers: toUse,
        })
    }

    handleFilterChange(attr, value) {
        let self = this
        this.setState({
            [attr]: value
        }, function () {
            self.filterFarmers()
        })

    }

    handleunpaidFilterChange(attr, value) {
        let self = this
        this.setState({
            [attr]: value
        }, function () {
            self.filterUnpaidFarmers()
        })

    }

    render() {
        const actions = [
            <button onClick={()=>this.handleClose()} className="uk-button uk-button-default " type="button">Cancel</button>,
            <button onClick={this.handleSendToEmail} style={styles.marginSide} className="uk-button uk-button-primary" type="button">Download PDF</button>
        ];
        return (
            <DocumentTitle title="Khula - Billing">
                <div className="main-content">
                    <p style={{backgroundColor:"white", padding:"1rem"}}>NB: Vouchers only become active when they have been paid. You can download invoices to pay. <br/> Please forward proof of payment to vouchers@khula.co.za as confirmation</p>
                    <div className="uk-grid-small uk-flex-row uk-text-center">

                        <div className="col-sm-6 col-xs-12 col-lg-6 col-md-6" style={{marginTop:"0.5rem",backgroundColor:"white",padding:"1rem"}}>

                            <h5><img alt="icon" style={{width:20,height:20}} src="/images/wallet-absa.png"/> Paid Invoices</h5>
                            <div className="input-group col-sm-3 col-xs-3 col-lg-3 col-md-3"
                                 style={{verticalAlign: "middle", paddingTop: "1rem"}}>
                                <input type="text" className="form-control" placeholder={"Search "+ this.state.paidVouchers.length + " Vouchers"}
                                       value={this.state.searchName}
                                       onChange={(e) => this.handleFilterChange("searchName", e.target.value)}
                                       style={{width:"auto",marginBottom:"1rem"}}
                                />
                            </div>
                            <div>
                                {this.state.filteredVouchers.map((voucher, i) =>
                                    <div>
                                        <div className="farmercontentcol col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                ID: {voucher.voucher.id}
                                            </div>

                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                {voucher.voucher.farmerDetails.name+" "+voucher.voucher.farmerDetails.surname}
                                            </div>

                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                Assigned Amount : {voucher.voucher.assignedAmount}
                                            </div>

                                            <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                Balance: {voucher.voucher.assignedAmount - voucher.voucher.value}
                                            </div>


                                                <Fab style={{backgroundColor: "green"}} size="small" color="primary"
                                                     aria-label="add" onClick={()=>this.handleViewInvoice(voucher)}>
                                                    <Icon>
                                                        pageview
                                                    </Icon>
                                                </Fab>

                                        </div>
                                    </div>
                                )}
                                {/*{this.state.paidKeys.reverse().map((getKey, i) =>*/}
                                {/*<ViewBills keySet={getKey} temp={{*/}
                                {/*"data": self.state.paidPayments[getKey],*/}
                                {/*"key": getKey,*/}
                                {/*"profile": self.state.profile,*/}
                                {/*"paid": true*/}
                                {/*}}/>*/}
                                {/*)}*/}
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 col-lg-6 col-md-6" style={{marginTop:"0.5rem",backgroundColor:"white",padding:"1rem",borderLeft:"10px solid whitesmoke"}}>
                            <h5><Icon>error_outline</Icon> Outstanding Invoices</h5>
                            <div className="input-group col-sm-3 col-xs-3 col-lg-3 col-md-3"
                                 style={{verticalAlign: "middle", paddingTop: "1rem"}}>
                                <input type="text" className="form-control" placeholder={"Search "+ this.state.unpaidVouchers.length + " Vouchers"}
                                       value={this.state.searchNameUnpaid}
                                       onChange={(e) => this.handleunpaidFilterChange("searchNameUnpaid", e.target.value)}
                                       style={{width:"auto",marginBottom:"1rem"}}
                                />
                            </div>
                            {this.state.filteredUnpaidVouchers.map((voucher, i) =>
                                <div>
                                    <div className="farmercontentcol col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            ID: {voucher.voucher.id}
                                        </div>

                                        <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            {voucher.voucher.farmerDetails.name+" "+voucher.voucher.farmerDetails.surname}
                                        </div>

                                        <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                            Assigned Amount : {voucher.voucher.assignedAmount}
                                        </div>

                                        <div className="col-sm-3 col-md-3 col-lg-3 c ol-xl-3">
                                            Balance: {voucher.voucher.assignedAmount - voucher.voucher.value}
                                        </div>


                                        <Fab style={{backgroundColor: "green"}} size="small" color="primary"
                                             aria-label="add" onClick={()=>this.handleViewInvoice(voucher)}>
                                            <Icon>
                                                pageview
                                            </Icon>
                                        </Fab>

                                    </div>
                                </div>
                            )}
                        </div>
                        {/*<th><span className="input-group-btn"><button type="button" className="btn btn-primary" onClick={(e)=>this.handleOpen(this.state.unpaidInvoices)}>Generate combined invoice</button></span> </th>*/}
                        {/*<hr/>*/}

                        {/*<div className="col-sm-2 col-xs-12 col-lg-2 col-md-2 addPadding ">*/}
                        {/*<div className="wrapper uk-card uk-card-hover ">*/}
                        {/*<div className="card radius shadowDepth1">*/}
                        {/*<div className="uk-grid-small uk-flex-row uk-text-center"*/}
                        {/*>*/}
                        {/*<FormControl className={{*/}

                        {/*minWidth: 120,*/}
                        {/*}}>*/}
                        {/*<InputLabel htmlFor="age-simple">All</InputLabel>*/}
                        {/*<Select*/}
                        {/*value={this.state.selectedYear}*/}
                        {/*onChange={(e) => this.processYearDemand(e.target.value)}*/}
                        {/*inputProps={{*/}
                        {/*name: 'year',*/}
                        {/*id: 'age-simple',*/}
                        {/*}}*/}
                        {/*>*/}
                        {/*<MenuItem value="">*/}
                        {/*<em>None</em>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem value={2015}>2015 Utilization</MenuItem>*/}
                        {/*<MenuItem value={2030}>2030 Utilization</MenuItem>*/}
                        {/*<MenuItem value={2046}>2046 Utilization</MenuItem>*/}
                        {/*</Select>*/}
                        {/*</FormControl>*/}
                        {/*/!*<input type="checkbox" className="btn-toggle-fullwidth"*!/*/}
                        {/*/!*onChange={() => this.updateSelected("all")}/><b>All</b>*!/*/}

                        {/*</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*group.push("Coal System  - ( Ogies - Richards Bay)")*/}
                        {/*group.push("Coal System  - ( Lephalale - Ogies)")*/}
                        {/*group.push("Coal System  - ( Phuzumoya - Richards Bay)")*/}
                        {/*group.push("Coal System  - ( Waterberg)")*/}
                        {/*<div className="col-sm-3 col-xs-12 col-lg-3 col-md-3 addPadding ">*/}
                        {/*<div className="wrapper uk-card uk-card-hover ">*/}
                        {/*<div className="card radius shadowDepth1">*/}
                        {/*<div className="uk-grid-small uk-flex-row uk-text-center">*/}

                        {/*<FormControlLabel control={<Checkbox*/}
                        {/*checked={this.state.coalSelectedOgies}*/}
                        {/*onChange={this.handleChange('coalSelectedOgies')}*/}
                        {/*value="coalSelectedOgies"*/}
                        {/*color="primary"*/}
                        {/*/>*/}
                        {/*} label="Coal System  - ( Ogies - Richards Bay)"/>*/}


                        {/*</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                    </div>
                    <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose}
                        contentStyle={modalStyle}
                        autoScrollBodyContent={true}>
                        <div >
                            <GetInvoice temp={{invoices:this.state.invoice,profile:this.state.profile}} />
                        </div>
                    </Dialog>
                </div>



            </DocumentTitle>
        );
    }

}

export default Bills;



// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Bills.js